import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="bg-gray-900 border-b border-gray-800 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center z-50" onClick={closeMobileMenu}>
            <img src="/icon.png" alt="PLAN B4 Logo" className="h-8 w-auto" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link
              to="/blog"
              className="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium transition-colors"
            >
              Blog
            </Link>
            <Link
              to="/changelog"
              className="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium transition-colors"
            >
              Changelog
            </Link>
            <Link
              to="/rss.xml"
              className="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium transition-colors"
            >
              RSS
            </Link>
            <Link
              to="/beta"
              className="text-red-400 hover:text-red-300 px-3 py-2 rounded-md text-sm font-medium transition-colors font-bold"
            >
              Beta
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileMenu}
            className="md:hidden z-50 p-2 rounded-md text-gray-300 hover:text-white hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-red-500 transition-colors"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              // Close icon
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              // Hamburger icon
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {isMobileMenuOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="md:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={closeMobileMenu}
          />
          
          {/* Mobile Menu */}
          <nav className="md:hidden fixed top-16 left-0 right-0 bg-gray-900 border-b border-gray-800 z-40 shadow-lg">
            <div className="px-4 pt-2 pb-4 space-y-1">
              <Link
                to="/blog"
                onClick={closeMobileMenu}
                className={`block px-3 py-3 rounded-md text-base font-medium transition-colors ${
                  location.pathname.startsWith('/blog')
                    ? 'bg-gray-800 text-white'
                    : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                }`}
              >
                Blog
              </Link>
              <Link
                to="/changelog"
                onClick={closeMobileMenu}
                className={`block px-3 py-3 rounded-md text-base font-medium transition-colors ${
                  location.pathname === '/changelog'
                    ? 'bg-gray-800 text-white'
                    : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                }`}
              >
                Changelog
              </Link>
              <Link
                to="/rss.xml"
                onClick={closeMobileMenu}
                className="block px-3 py-3 rounded-md text-base font-medium text-gray-300 hover:bg-gray-800 hover:text-white transition-colors"
              >
                RSS
              </Link>
              <Link
                to="/beta"
                onClick={closeMobileMenu}
                className={`block px-3 py-3 rounded-md text-base font-medium font-bold transition-colors ${
                  location.pathname === '/beta'
                    ? 'bg-red-900 text-red-300'
                    : 'text-red-400 hover:bg-red-900 hover:text-red-300'
                }`}
              >
                Beta
              </Link>
            </div>
          </nav>
        </>
      )}
    </header>
  );
};

export default Header; 
